"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListComponent = void 0;
//ANGULAR2 BITS
//Note: Renderer Service was deprecated on later Angular versions
const core_1 = require("@angular/core");
const router_1 = require("@angular/router");
const angular2_moment_1 = require("angular2-moment");
const platform_browser_1 = require("@angular/platform-browser");
//INTERNAL LIBRARY BITS
const bidder_service_1 = require("./bidder.service");
const notification_service_1 = require("./notification.service");
const permission_service_1 = require("./permission.service");
const loading_service_1 = require("./loading.service");
const branding_service_1 = require("./branding.service");
let ListComponent = class ListComponent {
    sortSign() {
        if (this.sortMod) {
            return '+';
        }
        else {
            return '-';
        }
    }
    constructor(_router, _bidder, _datePipe, _talk, _permission, _loading, _title, _branding) {
        this._router = _router;
        this._bidder = _bidder;
        this._datePipe = _datePipe;
        this._talk = _talk;
        this._permission = _permission;
        this._loading = _loading;
        this._title = _title;
        this._branding = _branding;
        this.sortList = 'name';
        this.sortMod = true;
        this.searchTerm = '';
        this._title.setTitle(this._branding.getControlCenterTitle());
        this.permission = JSON.parse(JSON.stringify(_permission.get()));
    }
    ngOnInit() {
        this.bidders = this._bidder.get();
        for (let b in this.bidders) {
            this.bidders[b].updatedAt = JSON.parse(this._datePipe.transform(this.bidders[b].updatedAt, 'x'));
            if (this.bidders[b].updatedBy) {
                this.bidders[b].updatedEmail = this.bidders[b].updatedBy.email || '';
            }
            else {
                this.bidders[b].updatedEmail = '';
            }
        }
    }
    openBidder(bidder) {
        this._loading.start("Loading Bidder...");
        this._router.navigate(['controlcenter/edit', bidder.id]);
    }
    sort(sortBy) {
        if (this.sortList == sortBy) {
            this.sortMod = !this.sortMod;
        }
        else {
            this.sortList = sortBy;
            this.sortMod = true;
        }
    }
    deleteBidder(bidder) {
        this._talk.confirm("Are you sure you want to delete this bidder file? Please note that deleting a bidder file does not deactivate that script from running on your page if it still remains there. If your Biddr360 header bidding script is still on your page, and you wish to remove it, you must remove the script from the code on your page.").then(resultPromise => {
            if (resultPromise.result)
                return resultPromise.result
                    .then(result => {
                    if (result) {
                        this._router.navigate(['/refresh']);
                        this._loading.start('Deleting Bidder...');
                        return this._bidder.delete(bidder.id).then(deleted => {
                            this._loading.stop();
                            this._router.navigate(['/controlcenter/list']);
                        });
                    }
                });
        }).catch(err => {
            console.error('unable to delete bidder', err);
        });
    }
    restoreBidder(bidder) {
        this._talk.confirm("Are you sure you want to restore this Bidder?").then(resultPromise => {
            if (resultPromise.result)
                return resultPromise.result
                    .then(result => {
                    if (result) {
                        this._router.navigate(['/refresh']);
                        this._loading.start('Restoring Bidder...');
                        return this._bidder.restore(bidder.id).then(deleted => {
                            this._loading.stop();
                            this._router.navigate(['/controlcenter/list']);
                        });
                    }
                });
        }).catch(err => {
            console.error('unable to delete bidder', err);
        });
    }
    pauseBidder(bidder) {
        if (typeof bidder.paused == 'undefined' || bidder.paused == false) {
            this._talk.confirm("Are you sure you want to pause this Bidder? Please note that by pausing this Bidder, it will automatically hit our servers so that your script stops running. To turn your script back on, simply click the play button.").then(resultPromise => {
                if (resultPromise.result)
                    return resultPromise.result
                        .then(result => {
                        if (result) {
                            this._router.navigate(['/refresh']);
                            this._loading.start('Pausing Bidder...');
                            return this._bidder.pause(bidder.id).then(res => {
                                this._loading.stop();
                                this._router.navigate(['/controlcenter/list']);
                            });
                        }
                    });
            }).catch(err => {
                console.error('unable to pause bidder', err);
            });
        }
        else {
            this._talk.confirm("Are you sure you want to turn your Bidder file back on?").then(resultPromise => {
                if (resultPromise.result)
                    return resultPromise.result
                        .then(result => {
                        if (result) {
                            this._router.navigate(['/refresh']);
                            this._loading.start('Restoring Bidder...');
                            return this._bidder.unpause(bidder.id).then(res => {
                                this._loading.stop();
                                this._router.navigate(['/controlcenter/list']);
                            });
                        }
                    });
            }).catch(err => {
                console.error('unable to unpause bidder', err);
            });
        }
    }
    copyBidder(event, bidderId) {
        event.stopPropagation();
        this._loading.start("Loading Bidder...");
        this._bidder.bidderId = bidderId;
        this._router.navigate(['controlcenter/copy']);
    }
};
exports.ListComponent = ListComponent;
exports.ListComponent = ListComponent = __decorate([
    (0, core_1.Component)({
        selector: 'my-list',
        templateUrl: 'app/list.component.html',
        styleUrls: ['styles/list.component.css']
    }),
    __metadata("design:paramtypes", [router_1.Router,
        bidder_service_1.BidderService,
        angular2_moment_1.DateFormatPipe,
        notification_service_1.NotificationService,
        permission_service_1.PermissionService,
        loading_service_1.LoadingService,
        platform_browser_1.Title,
        branding_service_1.BrandingService])
], ListComponent);
//# sourceMappingURL=list.component.js.map